// price_card_bg
import CountUp from "react-countup";

export default function FunFactCounterTwo({funFacts=[]}) {
  // Calculate dynamic grid classes based on funFacts length
  const getGridClasses = () => {
    const length = funFacts.length;
    if (length === 1) return "grid-cols-1 max-w-sm mx-auto";
    if (length === 2) return "grid-cols-1 sm:grid-cols-2 max-w-2xl mx-auto";
    if (length === 3) return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mx-auto";
    if (length === 4) return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4";
    if (length === 5) return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5";
    if (length === 6) return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6";
    return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6";
  };

  return (
    <section className="benefit-section-wrapper mb-16 pt-16 md:pb-[153px] w-full">
      <div className="mx-auto theme-container px-4 sm:px-6 lg:px-8">
        <div className={`grid ${getGridClasses()} gap-4 sm:gap-6 md:gap-8 lg:gap-[30px] h3-about-card relative overflow-hidden w-full`}>
          {funFacts.map((fact, index) => (
            <div
              key={index}
              data-aos="fade-left"
              data-aos-delay={fact.delay}
              className="relative flex flex-col items-center justify-center pt-4 pb-4 overflow-hidden border price_card_bg border-purple/30 rounded-3xl md:pt-6 md:pb-6 group"
            >
              {/* <div className="absolute inset-0 z-0 overflow-hidden transition-all duration-200 -translate-x-96 group-hover:translate-x-0 opacity-20">
                <img
                  src="./assets/images/home-three/about-card-bg.svg"
                  alt=""
                  className="w-full h-full object-contain object-center"
                />
              </div> */}
              <div className="relative z-10 flex flex-col items-center justify-center">
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white font-semibold pb-3 md:pb-[18px]">
                  <CountUp start={0} end={fact.value} duration={1.5} />
                  {fact.suffix}
                </h1>
                <div className="w-16 sm:w-20 border-2 border-purple"></div>
                <p className="pt-4 md:pt-6 font-semibold text-center text-sm sm:text-base md:text-lg text-paragraph px-2">
                  {fact.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
